import React from 'react';
import { Box, Button, Code, FormLabel, useToast } from '@chakra-ui/react';
import { FaCopy } from 'react-icons/fa';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';

interface JSONPreviewProps {
    caption?: string;
    data: any;
    clampHeight?: boolean;
}

export const JSONPreview: React.FC<JSONPreviewProps> = ({ data, caption, clampHeight }) => {
    const toast = useToast();
    const updateClipboard = (newClip: string) => {
        navigator.clipboard.writeText(newClip).then(
            () => {
                toast({
                    title: 'Success!',
                    description: 'Leaderboard config has been copied to your clipboard!',
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                });
            },
            () => {
                toast({
                    title: 'Error!',
                    description: 'There was a problem copying the config to your clipboard',
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                });
            },
        );
    };

    const copyJson = (data: any) => {
        updateClipboard(JSON.stringify(data, undefined, 4));
    };

    return (
        <Box>
            <FormLabel as="label">
                {typeof caption !== 'undefined' ? caption : 'JSON Preview:'}
            </FormLabel>

            <Box marginTop={3} marginBottom={3}>
                <Code width={'100%'} data-json={JSON.stringify(data)}>
                    <SyntaxHighlighter
                        language="json"
                        style={github}
                        showLineNumbers={true}
                        customStyle={
                            clampHeight
                                ? {
                                      maxHeight: '1000px',
                                  }
                                : {}
                        }
                    >
                        {JSON.stringify(data, null, 2)}
                    </SyntaxHighlighter>
                </Code>
            </Box>

            <Button id="copy-to-clipboard" leftIcon={<FaCopy />} onClick={() => copyJson(data)}>
                Copy to clipboard
            </Button>
        </Box>
    );
};
